import React from "react";

export const dataTahunTable = (handleEdit, handleDelete) => {
  return [
    {
      title: "Tahun",
      render: (rowData) => {
        return <span>{rowData.tahun}</span>;
      },
    },
    {
      title: "Status",
      render: (rowData) => {
        return <span>{rowData.status_tahun}</span>;
      },
    },
    {
      title: "Created At",
      render: (rowData) => {
        return <span>{rowData.created_at}</span>;
      },
    },
    {
      title: "Created By",
      render: (rowData) => {
        return <span>{rowData.created_by}</span>;
      },
    },
    {
      title: "Action",
      render: (rowData) => {
        return (
          <>
            <button
              className="bg-yellow-500 hover:bg-yellow-700 text-white font-bold py-2 px-4 rounded mr-2"
              onClick={(e) => handleEdit(rowData)}
            >
              Edit
            </button>
            <button
              className="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded"
              onClick={(e) => handleDelete(rowData)}
            >
              Delete
            </button>
          </>
        );
      },
    },
  ];
};
